import { render, staticRenderFns } from "./Tabbed.vue?vue&type=template&id=6c78f0b4&"
import script from "./Tabbed.vue?vue&type=script&lang=ts&"
export * from "./Tabbed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports